// Las banderas de la barra "N idiomas" (/libros, /oferta-panorama, las landings de
// coleccion y la ficha de cada libro), derivadas de la lista de idiomas publicos.
//
// Antes cada barra tenia escrito a mano el numero y su lista de banderas, en tres
// archivos: al abrir el turco (6-oct-2026) las tres siguieron diciendo "7" con siete
// banderas. Saliendo de PUBLICOS, el proximo idioma entra solo; lo unico que hay que
// sumar es su PNG en public/assets/images/flags/ y su linea aca (512x512, con la
// bandera 3:2 centrada, como las demas).
import { PUBLICOS } from '@/lib/idiomas';

const BANDERA_POR_IDIOMA = {
  es: 'flag_argentina',
  en: 'flag_uk',
  pt: 'flag_brazil',
  fr: 'flag_france',
  it: 'flag_italy',
  de: 'flag_germany',
  tr: 'flag_turkey',
  ja: 'flag_japan',
};

/** Nombres de archivo (sin extension) de las banderas, en el orden del selector de idioma. */
export const BANDERAS = PUBLICOS.map((ln) => BANDERA_POR_IDIOMA[ln]).filter(Boolean);

/** Cuantos idiomas se anuncian: los que tienen bandera, para que el numero y las banderas no se contradigan. */
export const CANTIDAD_DE_IDIOMAS = BANDERAS.length;

// Estilos de la fila. Con ocho banderas de 28 px la fila mide 294 px y en un celular
// de menos de 360 px de ancho la ultima bandera caia sola a un segundo renglon. La fila
// no corta y cada bandera se achica lo justo para entrar: de 360 px para arriba miden
// los mismos 28 px de siempre.
export const ESTILO_FILA_BANDERAS = { display: 'flex', justifyContent: 'center', gap: 10, marginTop: 10, flexWrap: 'nowrap' };
export const ESTILO_BANDERA = { flex: '0 1 28px', minWidth: 0, width: 28, height: 'auto', aspectRatio: '1 / 1', borderRadius: 0, objectFit: 'cover' };
